import { render, staticRenderFns } from "./PersonnelRecordGeneralTable.vue?vue&type=template&id=6b7440eb"
import script from "./PersonnelRecordGeneralTable.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordGeneralTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports